import React, { useEffect, useState } from "react";
import { Btn } from "../../../AbstractElements";
import { useAddFTPImportBatches, useFTPImportBatchesById, useUpdateFTPImportBatches } from "../hook/useFTPImportBatches";
import { Spinner } from "reactstrap";


interface FtpBatchModalContentProps {
 
  handleClose: () => void;
  selectedData?:any
  mode:any
}

const FtpBatchModalContent: React.FC<FtpBatchModalContentProps> = ({

  handleClose,
  selectedData,
  mode

}) => {

  const [label,setLabel]=useState('')
  const [attachedFunction,setAttachedFunction]=useState('')
  const [path,setPath]=useState('')
  const [isEnabled, setIsEnabled] = useState<boolean>(false);

const { data: ftpImportBatchesById, isLoading } = useFTPImportBatchesById({
  params: {
    ftpImportBatchId: selectedData?.FtpImportBatchId,
  },
  enable: mode === 'edit' && !!selectedData, // ✅ correct option
});

useEffect(()=>{
  if(mode=='edit'&&ftpImportBatchesById){
    const ftpImportData=ftpImportBatchesById?.data?.FTPImportBatchData;
    setLabel(ftpImportData?.Label||"")
    setAttachedFunction(ftpImportData?.AttachedFunction||"")
    if(ftpImportData?.Isenabled==1){
      setIsEnabled(true)
    }else{
      setIsEnabled(false)
    }
    setPath(ftpImportData?.FtpPath||"")
  }
},[ftpImportBatchesById,mode=='edit'])
const {mutate:addFTPImportBatch,isPending:isAdding }=useAddFTPImportBatches()
const {mutate:updateFTPImportBatch,isPending:isUpdating}=useUpdateFTPImportBatches()

const handleSubmit=(e:React.FormEvent)=>{
  e.preventDefault()
  const payload:any={
    label:label,
    attachedFunction:attachedFunction,
    ftpPath:path,
    isEnabled:isEnabled?1:0
  }
  console.log(payload)
  if (mode === "edit") {
        payload.ftpImportBatchId = selectedData?.FtpImportBatchId;
    updateFTPImportBatch(

         payload,
      {
        onSuccess: () => handleClose(),
      
      }
    );
  } else if(label && attachedFunction !="") {
    addFTPImportBatch(payload, {
      onSuccess: () => handleClose(),
   
    });
  }

}

  return (
<>
{isLoading?
    (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "60vh" }}
      >
        <Spinner color="primary" style={{ width: "3rem", height: "3rem" }} />
        {/* <span className="ms-3">Loading SGPI Brands...</span> */}
      </div>
    ):(
    <form onSubmit={handleSubmit}>
      {/* First Input */}
      <div className="col-md-12">
      <label style={{ fontWeight: "500",marginTop: "8px" }}>Label<span style={{color:'red'}}>*</span> </label>
      <input
        type="text"
        required
        className="form-control"
        placeholder="Enter Label"
        style={{
          border: "2px solid #EDEDED",
          borderRadius: "8px",
          padding: "13px",
          fontSize: "14px",
          width: "100%",
        }}
        value={label}
        onChange={(val)=>setLabel(val.target.value)}
      />
      </div>
      <div className="col-md-12">
      <label style={{ fontWeight: "500",marginTop: "8px" }}>Attached Function<span style={{color:'red'}}>*</span></label>
      <input
        type="text"
        required
        className="form-control"
        placeholder="Enter Attached Function"
        style={{
          border: "2px solid #EDEDED",
          borderRadius: "8px",
          padding: "13px",
          fontSize: "14px",
          width: "100%",
        }}
        value={attachedFunction}
        onChange={(val)=>setAttachedFunction(val.target.value)}
      />
      </div>
      <div className="col-md-12">
      <label style={{ fontWeight: "500",marginTop: "8px" }}>FTP Path<span style={{color:'red'}}>*</span></label>
      <input
        required
        type="text"
        className="form-control"
        placeholder="Enter FTP Path"
        style={{
          border: "2px solid #EDEDED",
          borderRadius: "8px",
          padding: "13px",
          fontSize: "14px",
          width: "100%",
        }}
        value={path}
        onChange={(val)=>setPath(val.target.value)}
      />
      </div>
      <div className="form-check mt-3">
          <input
            className="form-check-input"
            type="checkbox"
            id="isDefault"
            checked={isEnabled}
            onChange={(e) => setIsEnabled(e.target.checked)}
          />
          <label className="form-check-label" htmlFor="isDefault">
            is Enabled
          </label>
        </div>
      
      {/* Buttons */}
      <div className="d-flex justify-content-start mt-3 gap-2">
        <Btn
        style={{ backgroundColor: "#43B9B2", color: "white" }}
        type="submit"
        disabled={isAdding || isUpdating}  
      >
       {mode === "edit"
    ? isUpdating
      ? "Updating..."
      : "Update"
    : isAdding
      ? "Submitting..."
      : "Submit"}
      </Btn>
        <Btn
          style={{
            backgroundColor: "#F9FAFC",
            color: "#000",
            border: "1px solid #E0E0E0",
          }}
          type="button"
          onClick={handleClose}
        >
          Cancel
        </Btn>
      </div>
    </form>
        )
      }
      </>
  );
};

export default FtpBatchModalContent;
